var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-area"},[_c('div',{staticClass:"label"},[_vm._v("\n      "+_vm._s(_vm.labelName)+"\n    ")]),_vm._v(" "),(_vm.addLink !== null)?_c('nuxt-link',{staticClass:"more-link-pc",attrs:{"to":_vm.addLink}},[_vm._v("\n      "+_vm._s(_vm.addText)+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }